import { useEffect, useState } from 'react'

/** Renvoie `value` débouncé de `delay` ms (aucune requête par frappe). */
export function useDebounce<T>(value: T, delay = 300): T {
    const [debounced, setDebounced] = useState(value)
    useEffect(() => {
        const id = setTimeout(() => setDebounced(value), delay)
        return () => clearTimeout(id)
    }, [value, delay])
    return debounced
}
